import { relationshipTierIndex } from './relationshipLevels';

const TIER_KEYS = ['neutral', 'trusting', 'obedient', 'devoted'];

/**
 * Build POST /api/grok/request body like admin GrokRequestForm (playerId, playerName, history in prompt, characterData, kinks when Dominant).
 */
export function buildGrokChatRequestBody({
  playerId,
  playerName,
  characterId,
  characterDoc,
  historyLines,
  messageText,
  selectedGift = null,
  gameSettings,
  session,
  kinksCatalog = [],
  /** После выхода из сессий (как Unity AIChat.SessionData → Grok). */
  sessionFollowUp = null
}) {
  const nick = String(playerName || '').trim();
  const line = `${nick}: ${String(messageText || '').trim()}`;
  const historyText = (historyLines || []).filter(Boolean).join('\n');
  const fullPrompt = historyText ? `${historyText}\n${line}` : line;

  const row = (session?.characters || []).find((c) => String(c.characterId) === String(characterId));
  const rp = Number(row?.relationship) || 0;
  const tier = relationshipTierIndex(rp, gameSettings);
  const relationshipType = TIER_KEYS[Math.min(3, Math.max(0, tier))];

  const kinksData = [];
  if (characterDoc?.preferenceDominant && session?.kinks?.length && kinksCatalog.length) {
    const idSet = new Set((session.kinks || []).map(String));
    for (const k of kinksCatalog) {
      if (idSet.has(String(k._id))) {
        kinksData.push({ name: k.name, instruction: k.instruction || '' });
      }
    }
  }

  const c = characterDoc;
  const fu = sessionFollowUp && typeof sessionFollowUp === 'object' ? sessionFollowUp : {};
  return {
    playerId: String(playerId).trim(),
    playerName: nick,
    characterId: String(characterId),
    prompt: fullPrompt,
    characterData: c
      ? {
          name: c.name,
          instruction: c.instruction || '',
          relationshipType,
          neutral: c.neutral || '',
          trusting: c.trusting || '',
          obedient: c.obedient || '',
          devoted: c.devoted || ''
        }
      : null,
    kinksData,
    afterJoiSession: Boolean(fu.afterJoiSession),
    completedTasks: String(fu.completedTasks || ''),
    refusedTasks: String(fu.refusedTasks || ''),
    selectedGift,
    afterControlSession: Boolean(fu.afterControlSession),
    sessionHistory: String(fu.sessionHistory || '')
  };
}
